import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import "../../assets/welcome.css";

// Shown in place of private pages for accounts that haven't verified their email
const VerifyEmailNotice = () => {
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post("/api/auth/logout", {}, { withCredentials: true });
      setUserInfo(null);
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="verification-container">
      <div className="verification-card">
        <h1 className="verification-title">Verify Your Email</h1>
        <p className="verification-message">
          We sent a verification link to {userInfo?.email}. Please click the
          link in that email to access XSM Basketball.
        </p>
        <div className="verification-actions">
          {/* Reload re-runs the auth check so a newly verified account gets in */}
          <button
            onClick={() => window.location.reload()}
            className="verification-button"
          >
            I&apos;ve Verified My Email
          </button>
          <button
            onClick={() => navigate("/resend-verification")}
            className="verification-button verification-secondary"
          >
            Resend Verification Email
          </button>
          <button
            onClick={handleLogout}
            className="verification-button verification-secondary"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailNotice;
